import ServicesStatus from "../components/ServicesStatus";

export default function Integrazioni() {
  return (
    <div className="space-y-6" data-testid="integrazioni-page">
      <div>
        <h1 className="font-display text-2xl sm:text-3xl font-bold tracking-tight text-zinc-900">Integrazioni</h1>
        <p className="text-sm text-zinc-500 mt-1">Stato dei servizi collegati al tuo ristorante. La gestione tecnica è a carico di Dishenda.</p>
      </div>
      <ServicesStatus />
    </div>
  );
}
